<template lang="pug">
.label.mb-2(v-if="label") {{ label }}
CheckboxGroup(
  :name="name"
  :class="$attrs.class"
)
  .flex.items-center.gap-2(v-for="(option, idx) in options" :key="option.value")
    Checkbox(:inputId="getInputId(name, idx)" :value="option.value")
    label.label(:for="getInputId(name, idx)") {{ option.label }}
  
  //- pre {{ $field }}
  //- Message(v-if="$field?.invalid" severity="error" size="small" variant="simple") {{ $field.error?.message }} 

</template>

<script setup>
import { computed } from 'vue'
import Checkbox from 'primevue/checkbox'
import CheckboxGroup from 'primevue/checkboxgroup'
import Message from 'primevue/message'

defineOptions({inheritAttrs: false})

const props = defineProps({
  name:    { type: String, required: true },
  options: { type: Array, required: true, default: [] },
  label:   { type: String, required: false },
})

function getInputId(name, idx) {
  return `checkbox-${name}-${idx}`
}

// function onChange(event) {
//   const val = event.target?.value
//   console.log('Checkbox onChange', val, event)
// }

// const isSelected = computed({
//   get: () => {
//     console.log('isSelected GET')
//     return 'hello'
//   },
//   set: (option) => {
//     console.log('isSelected SET', option)
//     return option
//   },
// })
</script>